import { connect } from 'react-redux'
import Routes from './Routes'
import * as actions from '../../redux/authentication'

const mapStateToProps = (state) => ({
  authenticated: state.authentication.authenticated,
  orgID: state.authentication.orgID
})

export default connect(mapStateToProps, actions)(Routes)